import React from 'react';
import classNames from 'classnames';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import ReactTooltip from 'react-tooltip';


const Coordinates = props => (
    <div className="form-input-container">
        <div ><b>Facility Center Point (CONUS)</b></div>

        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}>
            <InputLabel shrink>Latitude</InputLabel>
            <Input
                data-tip data-for="latitude"
                inputProps={{ min: "24", max: "58", step: "any" }}
                type="number"
                name="latitude"
                value={props.latitude}
                onChange={props.handleInputChange}
                placeholder='Example: 32.789'/>
        </FormControl>
        <ReactTooltip id='latitude' place="bottom" type="light" effect="solid">
            WGS84 Latitude in decimal degrees.
        </ReactTooltip>

        <FormControl className={classNames(props.classes.margin, props.classes.formControl)}>
            <InputLabel shrink>Longitude</InputLabel>
            <Input
                data-tip data-for="longitude"
                inputProps={{ min: "-126", max: "-66", step: "any" }}
                type="number"
                name="longitude"
                value={props.longitude}
                onChange={props.handleInputChange}
                placeholder='Example: -97.342'/>
        </FormControl>
        <ReactTooltip id='longitude' place="bottom" type="light" effect="solid">
            WGS84 Longitude in decimal degrees (- for west).
        </ReactTooltip>
    </div>
)
export default Coordinates;
